import React, { useEffect, useState, memo } from 'react';
// Helper functions defined outside the component to avoid hoisting issues
const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = name => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
// Memoize the component to prevent unnecessary re-renders
export const CountdownBadge = memo(function CountdownBadge() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    // Initialize state from cookie if available (only once at component mount)
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('copiesLeft');
      return storedCount ? parseInt(storedCount) : 200;
    }
    return 200;
  });
  useEffect(() => {
    // Set initial cookie if needed
    if (!getCookie('copiesLeft')) {
      setCookie('copiesLeft', '200', 30);
    }
    // Defer the interval setup to not block initial page load
    let intervalId;
    const timeoutId = setTimeout(() => {
      // Set up interval to decrease count every 5 seconds
      intervalId = setInterval(() => {
        setCopiesLeft(prevCount => {
          // Don't go below 3
          const newCount = prevCount > 3 ? prevCount - 1 : 3;
          // Update cookie with new count
          setCookie('copiesLeft', newCount.toString(), 30);
          return newCount;
        });
      }, 5000);
    }, 2000); // Delay start by 2 seconds
    // Clean up interval on component unmount
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="bg-amber-50 text-amber-800 px-3 py-1 rounded-full text-xs font-medium inline-flex items-center" data-id="element-17">
      <svg className="w-3 h-3 mr-1 text-amber-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-18">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-19" />
      </svg>
      Solo {copiesLeft} copias disponibles
    </div>;
});